const handleAccordionToggle = (
  $accordionList,
  $currentAccordionButton,
  $accordionButtons,
) => {
  const $currentAccordionContentSelector =
    $currentAccordionButton.dataset.accordionTarget;
  const $currentAccordionContent = $accordionList.querySelector(
    $currentAccordionContentSelector,
  );

  if ($currentAccordionContent) {
    if ($currentAccordionButton.getAttribute('aria-expanded') == 'false') {
      $currentAccordionButton.setAttribute('aria-expanded', true);
      $currentAccordionContent.setAttribute('aria-hidden', false);
    } else {
      $currentAccordionButton.setAttribute('aria-expanded', false);
      $currentAccordionContent.setAttribute('aria-hidden', true);
    }
  }

  [...$accordionButtons].forEach($accordionButton => {
    const $accordionContentSelector = $accordionButton.dataset.accordionTarget;
    const $accordionContent = $accordionList.querySelector(
      $accordionContentSelector,
    );
    if ($accordionContent && $accordionButton != $currentAccordionButton) {
      $accordionButton.setAttribute('aria-expanded', false);
      $accordionContent.setAttribute('aria-hidden', true);
    }
  });
};

export const accordions = () => {
  const $accordionLists = document.querySelectorAll('[data-accordion]');

  if ($accordionLists.length) {
    [...$accordionLists].forEach($accordionList => {
      const $accordionButtons = $accordionList.querySelectorAll(
        '[data-accordion-button]',
      );

      if ($accordionButtons.length) {
        [...$accordionButtons].forEach($accordionButton => {
          $accordionButton.addEventListener('click', function() {
            handleAccordionToggle(
              $accordionList,
              $accordionButton,
              $accordionButtons,
            );
          });
        });
      }
    });
  }
};
